<template>
  <ModalContainer :showModal="showModal" :title="isEdit ? 'Edit Customer' : 'Create Customer'" @closeModal="closeModal">
    <div id="modal-body" class="p-6">
      <AlertDanger v-if="alert_danger" :text="alert_text" @closeAlertDanger="hideAlertDanger()" />
      <InputForm
        id="customer-name"
        v-model="customer.name"
        input_class="w-full mb-5"
        label="Full Name"
        label_class="mb-1 block text-start"
        type="text"
        placeholder="e.g. John Doe"
        :is_required="true"
      />
      <InputForm
        id="customer-phone"
        v-model="customer.phone_number"
        input_class="w-full mb-5"
        label="Phone Number"
        label_class="mb-1 block text-start"
        type="text"
        placeholder="e.g. 081234567890"
        :is_required="true"
      />
      <InputForm
        id="customer-email"
        v-model="customer.email"
        input_class="w-full mb-5"
        label="Email"
        label_class="mb-1 block text-start"
        type="text"
        placeholder="e.g. example@email.com"
        :is_required="true"
      />
      <InputForm
        id="customer-birthdate"
        v-model="customer.birthdate"
        input_class="w-full mb-5"
        label="Birthdate"
        label_class="mb-1 block text-start"
        type="date"
        :is_required="true"
      />
      <InputForm
        id="customer-address"
        v-model="customer.address"
        input_class="w-full mb-5"
        label="Address"
        label_class="mb-1 block text-start"
        type="text"
      />
      <Select
        option_placeholder="Select Branch"
        select_class="w-full"
        valueKey="id"
        labelKey="name"
        :options="allBranches"
        v-model="customer.branch_id"
      />
    </div>
    <div class="modal-footer pb-6">
      <div class="flex justify-center gap-2">
        <Button @click="closeModal" id="close-modal" button_text="Close" />
        <Button @click="submit()" id="submit" button_text="Submit" />
      </div>
    </div>
  </ModalContainer>
</template>

<script>
import ModalContainer from "@/components/modals/ModalContainer.vue";
import Button from "@/components/buttons/Button.vue";
import InputForm from "@/components/form/InputForm.vue";
import AlertDanger from "@/components/alerts/AlertDanger.vue";
import { mapActions, mapGetters } from "vuex";
import { validationPhoneNumber, validationEmail } from "@/helpers/validation";
import Select from '@/components/form/Select.vue';

export default {
  name: "ModalAddCustomer",
  props: {
    customerData: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: Number,
      default: null,
    },
  },
  emits: ["openAlertSuccess_CustomerCreated", "openAlertSuccess_CustomerUpdated", "closeModal"],
  components: {
    InputForm,
    Button,
    AlertDanger,
    ModalContainer,
    Select,
  },
  data() {
    return {
      showModal: true,
      alert_danger: false,
      alert_text: "",
      isEdit: false,
      customer: {
        id: null,
        name: '',
        phone_number: '',
        birthdate: null,
        email: '',
        address: '',
        branch_id: null,
      },
    };
  },
  computed: {
    ...mapGetters("branches", ["allBranches"]),
  },
  async created() {
    await this.$store.dispatch('branches/fetchBranches');
    
    if (this.customerData) {
      this.isEdit = true;
      const customerData = await this.fetchCustomerById(this.id);
      this.customer.id = customerData.id;
      this.customer.name = customerData.name;
      this.customer.phone_number = customerData.phone_number;
      this.customer.birthdate = customerData.birthdate;
      this.customer.email = customerData.email;
      this.customer.address = customerData.address;
      this.customer.branch_id = customerData.branch_id;
    }
  },
  methods: {
    ...mapActions("customers", ["createCustomer", "updateCustomer", "fetchCustomerById"]),
    validationPhoneNumber, validationEmail,

    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit("closeModal");
      }, 100);
    },

    capitalizeName(name) {
      return name
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },

    async submit() {
      if (!this.customer.name) {
        this.alert_danger = true;
        this.alert_text = "Name cannot be empty!";
        return;
      }
      if (!validationPhoneNumber(this.customer.phone_number)) {
        this.alert_danger = true;
        this.alert_text = "The telephone number format consists of 10 - 13 numeric characters!";
        return;
      }
      this.customer.name = this.capitalizeName(this.customer.name);
      // console.log('customer: ', this.customer);
      try {
        if (this.isEdit) {
          await this.updateCustomer(this.customer);
          this.$emit('openAlertSuccess_CustomerUpdated');
        } else {
          await this.createCustomer(this.customer);
          this.$emit('openAlertSuccess_CustomerCreated');
        }
        this.closeModal();
      } catch (error) {
        console.error(error);
        this.alert_danger = true;
        this.alert_text = "Error: " + error.message;
      }
    },

    hideAlertDanger() {
      this.alert_danger = false;
      this.alert_text = "";
    },
  },
};
</script>